<template>
  <v-dialog
    v-model="enableDialog"
    persistent
    width="800"
  >
    <v-card class="rounded_card">
      <v-stepper v-model="stepper">
        <v-stepper-header>
          <v-stepper-step
            step="1"
            :complete="stepper > 1"
          >
            招待情報の入力
          </v-stepper-step>
          <v-divider />
          <v-stepper-step
            step="2"
            :complete="stepper > 2"
          >
            送信先の選択
          </v-stepper-step>
          <v-divider />
          <v-stepper-step
            step="3"
            :complete="stepper > 3"
          >
            送信完了
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <invitation-user-info
              v-if="user"
              :user="user"
              :emission-id="emissionId"
              @toNextStep="nextStep"
            />
          </v-stepper-content>
          <v-stepper-content step="2">
            <invitation-select-send
              v-if="user"
              :user="user"
              :emission-id="emissionId"
              @toNextStep="nextStep"
              @toBackStep="backStep"
            />
          </v-stepper-content>
          <v-stepper-content step="3">
            <invitation-completed
              v-if="user"
              :user="user"
            />
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="closeButtonClickEvent">
          閉じる
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InvitationUserInfo from '../forms/_UserInfo'
import InvitationSelectSend from '../forms/_SelectSend'
import InvitationCompleted from '../forms/_Completed'
export default {
  name: 'EmissionInvitationDialog',
  components: {
    InvitationUserInfo,
    InvitationSelectSend,
    InvitationCompleted
  },
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false
    },
    emissionId: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    return {
      stepper: 1,
      user: {
        name: null,
        email: null,
        mobile_number: null,
        send_type: null
      }
    }
  },
  computed: {},
  watch: {
    /**
     * enableDialogの監視
     * trueに変更された場合は初期表示情報を取得
     * @param newVal
     */
    enableDialog (newVal) {
      Object.assign(this.$data.user, this.$options.data().user);
      this.stepper = 1
    }
  },
  created() {
  },
  methods: {
    closeButtonClickEvent() {
      this.$emit('closeCallback')
    },
    nextStep () {
      this.stepper++
    },
    backStep () {
      this.stepper--
    },
  }
}
</script>

<style scoped lang="scss">

</style>
